import { Injectable } from '@angular/core';
import { throwError, Observable, BehaviorSubject } from 'rxjs';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { ActivatedRoute, RouteConfigLoadEnd, Router, RouterLink } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class NavigationService {

  menu$: BehaviorSubject<any>;
  private menuSelectedItem: BehaviorSubject<string> = new BehaviorSubject<string>("");
  public menuSelectedItem$ = this.menuSelectedItem.asObservable();

  private showMenu: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public showMenu$ = this.showMenu.asObservable();
  userSettings: Observable<any>;

  public sRole = "";
  public sView = "";
  public sGroupBy = "";
  public sRoleByName = "";
  
  public sLandscapePage = "";

  public menuLoaded: boolean = false;
  public useNewLayout$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);

  public landscapePageConfig = {
    showLegend: false,
    page: 1,
    useNewLayout: false,
    pageView: 3,
    sAccount: null
  };

  constructor(
    private http: HttpClient,
    private activatedRoute: ActivatedRoute,
    private router: Router,
  ) {
    // initalise the menus as blank
    this.menu$ = new BehaviorSubject([]);
  }

  getUserSettings() {
    this.userSettings = this.http.get('/api/data/user')
    return this.userSettings
  }

  loadMenus() {

    this.http.get('/api/data/menus').subscribe(
      (response: any) => {
        this.menuLoaded = true;
        this.menu$.next(response);
      }, (error: any) => {
        console.log('unable to get menus');
      }
    )
  }

  setShowMenu(x): void {
    this.showMenu.next(x)
  }

  setMenuSelectedItem(x: string): void {
    this.menuSelectedItem.next(x);
  }

  setLandscapePage(page){
    this.sLandscapePage = page;
  }

  setLandscapeConfig(showLegend, page, useNewLayout, pageView, sAccount) {
    this.landscapePageConfig.showLegend = showLegend;
    this.landscapePageConfig.page = page;
    this.landscapePageConfig.useNewLayout = useNewLayout;
    this.landscapePageConfig.pageView = pageView;
    this.landscapePageConfig.sAccount = sAccount;
  }

  toggleLayout() {
    const layout = this.useNewLayout$.value ? 'old' : 'new';
    this.http.post(`/api/data/switchlayout?layout=${layout}`, null).subscribe(res => {});
    this.useNewLayout$.next(!this.useNewLayout$.value);
  }
}
